import React from "react";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Ticker from "@/components/landing/Ticker";
import PainPoints from "@/components/landing/PainPoints";
import FeaturesScroll from "@/components/landing/FeaturesScroll";
import Backers from "@/components/landing/Backers";
import HowItWorks from "@/components/landing/HowItWorks";
import Strategies from "@/components/landing/Strategies";
import Innovation from "@/components/landing/Innovation";
import CodingServices from "@/components/landing/CodingServices";
import Testimonials from "@/components/landing/Testimonials";
import Pricing from "@/components/landing/Pricing";
import FAQ from "@/components/landing/FAQ";
import CTASection from "@/components/landing/CTASection";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-white text-[#0f172a]">
      <Header />
      <Hero />
      <Ticker />
      <PainPoints />
      <FeaturesScroll />
      <HowItWorks />
      <Strategies />
      <Innovation />
      <CodingServices />
      <Backers />
      <Testimonials />
      <Pricing />
      <FAQ />
      <CTASection />
      <Footer />
    </main>
  );
}
